<template>
  <div class="product-vignette__price-wrapper" :data-testId="`${testId}-vignette_price-wrapper`">
    <PromoCode :product="product" />
    <div v-if="hasDiscount" :class="['price', isRrpPrice(product) ? 'price-not-highlighted' : null]">
      <span class="price--market-price-label">{{ $t(getMarketPriceType()) }}</span>
      <span class="price--old qa-thematic-price" :data-testId="`${testId}-vignette_price-displayPricePreDiscount`">
        {{ getDisplayPrice }}</span
      >
      <div class="price-wrapping">
        <div class="price--discounted" :data-testId="`${testId}-vignette_price-discounted`">
          {{ formattedPrice(discount.discounted_price) }}
        </div>
        <div class="sticker">
          <div class="promotion-sticker">
            <span :data-testId="`${testId}-vignette_sticker`">{{
              getDiscountAmount(discount.discount_type, discount.total_discount)
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <span v-if="!hasDiscount" class="price--regular qa-thematic-price" :data-testId="`${testId}-vignette_price-displayPriceNoDiscount`">
      {{ getDisplayPrice }}
    </span>
  </div>
</template>

<script lang="js">
import { formatPrice, brandingImporter } from '../../../utils/index.js';
import PromoCode from './PromoCode.vue';

export default {
  name: 'price',
  components: { PromoCode },
  props: {
    product: Object,
    discount: Object,
    testId: String,
  },
  computed: {
    hasDiscount() {
      return this.discount && !!this.discount.discount_type && this.discount.total_discount > 0;
    },
    getCurrency() {
      const { currency } = brandingImporter();
      return currency;
    },
    getDisplayPrice() {
      const { marketPrice, price } = this.product;
      return marketPrice ? this.formattedPrice(marketPrice) : this.formattedPrice(price);
    },
  },
  methods: {
    formattedPrice(price) {
      return formatPrice(Number.parseFloat(price), this.getCurrency);
    },
    getDiscountAmount(discountType, totalDiscount) {
      return discountType === 'percentage' ? `-${ totalDiscount }%` : `-${ formatPrice(Number.parseFloat(totalDiscount), this.getCurrency) }`;
    },
    isRrpPrice(product) {
      const { marketPrice, marketPriceType } = product;
      return (marketPrice && marketPriceType === 'PartnerPrice') || (marketPrice && marketPriceType === 'SecondaryBrandPrice');
    },
    getMarketPriceType() {
      const { marketPrice, marketPriceType } = this.product;
      if (!marketPrice || (marketPrice && marketPriceType === 'OverPricing' || (marketPrice && !marketPriceType))) {
        return 'overPrice';
      }
      if (this.isRrpPrice(this.product)) {
        return 'rrpPrice';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../scss/variables';

.price {
  font-size: rem-calc(16);
  line-height: rem-calc(24);
  font-family: $brand-font-medium;
  font-weight: normal;

  @media #{$desktop-up} {
    font-size: rem-calc(20);
    line-height: rem-calc(24);
  }

  &.price-not-highlighted {
    & .price--old {
      text-decoration: none;
    }

    & .price--discounted {
      color: $collection-black;
    }
  }

  &--market-price-label {
    font-size: rem-calc(12);
    line-height: rem-calc(18);
    color: #595959;
    vertical-align: initial;
    white-space: nowrap;
    @media #{$desktop-up} {
      font-size: rem-calc(14);
      line-height: rem-calc(18);
    }
  }

  &--regular {
    font-size: rem-calc(20);
    font-family: $brand-font-medium;
    line-height: 1;
    color: #1A203C;
  }

  &--old {
    font-size: rem-calc(12);
    line-height: rem-calc(18);
    text-decoration: line-through;
    color: #595959;
    vertical-align: initial;
    white-space: nowrap;

    @media #{$desktop-up} {
      font-size: rem-calc(14);
      line-height: rem-calc(18);
    }
  }

  &--discounted {
    color: #df1d42;
    display: flex;
    flex-wrap: wrap;
    margin-right: rem-calc(10);
    white-space: nowrap;
    margin-top: rem-calc(3);
  }

  .promotion-sticker {
    width: auto;
    flex-wrap: wrap;
    overflow: hidden;
    color: $collection-promo-red;
    background: $collection-promo-background;
    border-radius: rem-calc(3);
    padding: rem-calc(6) 0;
    font-size: rem-calc(13);
    line-height: rem-calc(17);
    letter-spacing: rem-calc(1);
    font-family: $brand-font-bold;

    span {
      margin: rem-calc(5);
    }
  }
}

.price-wrapping {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  margin-top: rem-calc(3);
}
</style>
